import AssigneeEditor from "./AssigneeEditor";

export default AssigneeEditor;
